import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit {
  timeline = [
    // {
    //   heading: "Infosys",
    //   duration: "Present",
    //   subtitle: "",
    //   content: "Upcoming Full stack develover at Infosys!",
    //   className1: "mar-left",
    //   className2: "prt_about_learnbox_right"
    // },
    {
      heading: "Bachelor Of Computer Application",
      duration: "2020",
      subtitle: "Chhatrapati Shahu Ji Maharaj University, Kanpur",
      content: "Successfully completed my BCA  from Chhatrapati Shahu Ji Maharaj University, Kanpur.",
      className1: "mar-right",
      className2: "prt_about_learnbox_left"
    },
    {
      heading: "Higher Secondary(12th)",
      duration: "2017",
      subtitle: "ISC Board",
      content: "Successfully completed my intermediate studies in 2017 from Radha Krishna Memorial Education Centre, Kanpur.\n" +
        "Major: PCM.",
      className1: "mar-left",
      className2: "prt_about_learnbox_right"
    },
    {
      heading: "Secondary Stage(10th)",
      duration: "2015",
      subtitle: "ICSE Board",
      content: "Successfully completed my high school studies in 2015 from City Model College, Kanpur.",
      className1: "mar-right",
      className2: "prt_about_learnbox_left"
    }
    ];

  constructor() { }

  ngOnInit(): void {
  }

}
